import React, { useEffect, useState, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Grid, Button, Modal, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { rentService, billService } from '../../../services'
import CrudEmpty from '../../crud/CrudEmpty'
import Form from '../../form/Form'
import HeaderSus from '../../sus/HeaderSus'
import styled from 'styled-components'
import { ToastContainer, toast } from 'react-toastify'
import { Box } from '@mui/system'
import { resolveBlock } from '../../common/blockAction'
import { BlockModal } from '../../common/BlockFeedback'

const moment = require('moment')

type NewRentParams = {
    id: string
}

const initElementLine = {
    user: { id: null, name: '', email: '' },
    suscription: { id: null, name: '' },
    start: null,
    end: null,
}

export default function EditRent() {
    const style = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        maxWidth: '80%',
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    }

    const navigate = useNavigate()
    const { t, i18n } = useTranslation()
    var { id } = useParams<NewRentParams>()
    var aux = {
        suscription: { id: id },
    }

    const [
        {
            object,
            error,
            errorBlock,
            openModalConfirmFree,
            openModalConfirmPay,
            openCommentStart,
            openCommentEnd,
            motive,
            comment,
        },
        setState,
    ] = React.useState<any>({
        object: { ...initElementLine, ...aux },
        error: '',
        // MOBD-66: bloqueo de usuario devuelto por el backend en las acciones de ciclo de vida.
        errorBlock: null,
        openModalConfirmFree: false,
        openModalConfirmPay: false,
        openCommentStart: false,
        openCommentEnd: false,
        motive: '',
        comment: '',
    })

    const estructureform = [
        // user.email es solo lectura; el endpoint /admin/user/combo requería ADMIN
        // (403 para rol SUSCRIPTION) y el valor ya viene en la respuesta de /one.
        {
            type: 'input',
            name: 'user.email',
            readonly: true,
            col: 4,
        },
        {
            type: 'input',
            name: 'modality',
            readonly: true,
            col: 4,
        },
        {
            type: 'autocomplete',
            name: 'rentalState',
            col: 4,
            options: [
                {
                    key: 'PENDINGACCEPT',
                    name: 'Pendiente de aceptación',
                },
                {
                    key: 'ACCEPT',
                    name: 'Aceptado',
                },
                {
                    key: 'PROBLEMFIANCE',
                    name: 'Problema con la preautorización',
                },
                {
                    key: 'START',
                    name: 'Iniciado',
                },
                {
                    key: 'END',
                    name: 'Finalizado',
                },
                {
                    key: 'CANCEL',
                    name: 'Cancelado',
                },
            ],
            readonly: true,
        },
        {
            type: 'input',
            name: 'start',
            inputtype: 'datetime-local',
            col: 4,
        },
        {
            type: 'input',
            name: 'end',
            inputtype: 'datetime-local',
            col: 4,
        },
        {
            type: 'input',
            name: 'start_real',
            inputtype: 'datetime-local',
            col: 4,
        },
        {
            type: 'input',
            name: 'end_real',
            inputtype: 'datetime-local',
            col: 4,
        },
        {
            type: 'input',
            name: 'km_start',
            col: 2,
        },
        {
            type: 'input',
            name: 'km_end',
            col: 2,
        },
        {
            type: 'input',
            name: 'fuel_level_start',
            col: 2,
        },
        {
            type: 'input',
            name: 'fuel_level_end',
            col: 2,
        },
    ]

    useEffect(() => {
        searchData()
    }, [])

    const searchData = () => {
        rentService.one(id, (data, error) => {
            if (data && data.data) {
                setState((currentState) => ({
                    ...currentState,
                    ['object']: data.data,
                }))
            }
        })
    }

    const closeModalConfirmFree = () => {
        setState((currentState) => ({
            ...currentState,
            ['openModalConfirmFree']: false,
        }))
    }

    const closeModalConfirmPay = () => {
        // Reset motive al cerrar para que la próxima apertura aparezca limpia.
        setState((currentState) => ({
            ...currentState,
            ['openModalConfirmPay']: false,
            ['motive']: '',
        }))
    }

    const closeCommentStart = () => {
        setState((s) => ({ ...s, openCommentStart: false, comment: '' }))
    }

    const closeCommentEnd = () => {
        setState((s) => ({ ...s, openCommentEnd: false, comment: '' }))
    }

    const cancelForm = (object) => {
        window.history.back()
    }

    // El formulario es de solo lectura; este handler no llega a usarse.
    const saveForm = (object) => {}

    const closeModal = () => {
        setState((currentState) => ({
            ...currentState,
            ['error']: '',
        }))
    }

    // MOBD-66: enruta el fallo de una acción del backend. Si trae un bloqueo de usuario, se muestra
    // el aviso enriquecido (motivo + solución + acción) que ya viene redactado; si no, se mantiene el
    // modal de error de texto plano de siempre. Aditivo: sin bloqueo el comportamiento no cambia.
    const handleFail = (fail) => {
        const blockInfo = resolveBlock(fail)
        if (blockInfo) {
            setState((s) => ({ ...s, errorBlock: blockInfo }))
        } else {
            setState((s) => ({ ...s, error: fail && fail.mes ? fail.mes : '' }))
        }
    }

    const closeCar = (idCar) => {
        rentService.closecar(idCar, (data, fail) => {
            if (data && data.data) {
                toast.success('Se ha enviado la acción', {
                    position: toast.POSITION.TOP_CENTER,
                })
            } else {
                handleFail(fail)
            }
        })
    }

    const openCar = (idCar) => {
        rentService.openCar(idCar, (data, fail) => {
            if (data && data.data) {
                toast.success('Se ha enviado la acción', {
                    position: toast.POSITION.TOP_CENTER,
                })
            } else {
                handleFail(fail)
            }
        })
    }

    const end = () => {
        setState((currentState) => ({
            ...currentState,
            ['openModalConfirmFree']: true,
        }))
    }

    const endPay = () => {
        setState((currentState) => ({
            ...currentState,
            ['openModalConfirmPay']: true,
        }))
    }

    // F5 - Finalizar sin cargos: el backend no liquida nada.
    const sendFreeFiance = () => {
        rentService.freefiance(id, (data, fail) => {
            if (data && data.data) {
                window.location.reload()
            } else {
                handleFail(fail)
            }
        })
    }

    const cancel = () => {
        rentService.cancel(id, (data, fail) => {
            if (data && data.data) {
                window.location.reload()
            } else {
                handleFail(fail)
            }
        })
    }

    // F5 - Finalizar y liquidar: el backend autocalcula la liquidación.
    // Solo se envía el motivo; el backend ignora cualquier importe (divergencia #2).
    const sendPayFiance = () => {
        var body = {
            motiveFiance: motive,
        }

        rentService.payfiance(id, body, (data, fail) => {
            if (data && data.data) {
                window.location.reload()
            } else {
                handleFail(fail)
            }
        })
    }

    // F4 - Comentarios de recepción al iniciar y finalizar.
    // El backend hace @RequestBody SuscriptionRental y lee data.getCommentStart()/getCommentEnd(),
    // por eso el JSON debe usar la clave exacta del campo (no "comment").
    const sendCommentStart = () => {
        rentService.commentStart(id, { commentStart: comment }, (data, fail) => {
            if (data && data.data) {
                setState((s) => ({
                    ...s,
                    openCommentStart: false,
                    comment: '',
                }))
                searchData()
            } else {
                handleFail(fail)
            }
        })
    }

    const sendCommentEnd = () => {
        rentService.commentEnd(id, { commentEnd: comment }, (data, fail) => {
            if (data && data.data) {
                setState((s) => ({
                    ...s,
                    openCommentEnd: false,
                    comment: '',
                }))
                searchData()
            } else {
                handleFail(fail)
            }
        })
    }

    const lineAmount = (line) => {
        var v =
            line['total'] != null
                ? line['total']
                : line['price'] != null
                ? line['price']
                : 0
        return (+v).toFixed(2)
    }

    const downloadInvoice = () => {
        billService.print(
            object['idBill'],
            'Liquidacion-Rent-' + object['id'] + '.pdf',
            (data, err) => {
                if (data) {
                    toast.success('Se ha descargado la factura', {
                        position: toast.POSITION.TOP_CENTER,
                    })
                }
            }
        )
    }

    const isLoaded = object && object['id']
    const isCancel = isLoaded && object['rentalState'] == 'CANCEL'
    const isStart = isLoaded && object['rentalState'] == 'START'
    const isEnd = isLoaded && object['rentalState'] == 'END'
    // Sin object.id la rentalState es undefined: sin este guard, las condiciones
    // != START/END/CANCEL evaluarían true y "Cancelar" aparecería durante la carga.
    const isCancellable =
        isLoaded &&
        object['rentalState'] != 'START' &&
        object['rentalState'] != 'END' &&
        object['rentalState'] != 'CANCEL' &&
        object['rentalState'] != ''

    return (
        <CrudEmpty i18n={'rent'} goback={true}>
            <Grid container>
                {/* F6 - Aviso de cancelación */}
                {isCancel && (
                    <Grid xs={12}>
                        <PanelAviso
                            style={{
                                background:
                                    object['cancelReason'] ==
                                    'PAYMENT_TIMEOUT'
                                        ? '#e74c3c'
                                        : '#7f8c8d',
                            }}
                        >
                            {object['cancelReason'] == 'PAYMENT_TIMEOUT'
                                ? 'Servicio cancelado por impago — el cliente no completó el pago dentro de los 10 minutos.'
                                : 'Alquiler cancelado por recepción.'}
                        </PanelAviso>
                    </Grid>
                )}
                <Grid xs={12}>
                    <HeaderSus
                        id={
                            object['suscription']
                                ? object['suscription']['id']
                                : -1
                        }
                    />
                </Grid>
                <Grid xs={12}>
                    <PanelForm>
                        <Form
                            t={t}
                            i18n={'rent'}
                            objectform={object}
                            fields={estructureform}
                            searchFilter={saveForm}
                            cleanFilter={cancelForm}
                            notierror={null}
                            onlyRead={true}
                            isHiddenCancel={true}
                        />
                    </PanelForm>
                </Grid>

                {/* F4 - Comentarios de recepción */}
                {(object['commentStart'] || object['commentEnd']) && (
                    <Grid xs={12}>
                        <PanelForm style={{ marginTop: '1em' }}>
                            <h3 style={{ marginTop: 0 }}>
                                Comentarios de recepción
                            </h3>
                            {object['commentStart'] && (
                                <p>
                                    <b>Al iniciar: </b>
                                    {object['commentStart']}
                                </p>
                            )}
                            {object['commentEnd'] && (
                                <p>
                                    <b>Al finalizar: </b>
                                    {object['commentEnd']}
                                </p>
                            )}
                        </PanelForm>
                    </Grid>
                )}

                {/* F5 - Liquidación automática y factura */}
                {isEnd && (
                    <Grid xs={12}>
                        <PanelForm style={{ marginTop: '1em' }}>
                            <h3 style={{ marginTop: 0 }}>
                                Liquidación del alquiler
                            </h3>
                            {object['lines'] &&
                            object['lines'].length > 0 ? (
                                <div>
                                    {object['lines'].map((line, i) => (
                                        <Grid
                                            container
                                            key={i}
                                            style={{
                                                borderBottom:
                                                    '1px solid #eee',
                                                padding: '6px 0',
                                            }}
                                        >
                                            <Grid item xs={8}>
                                                {line['concept']}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={4}
                                                style={{
                                                    textAlign: 'right',
                                                }}
                                            >
                                                {lineAmount(line)} €
                                            </Grid>
                                        </Grid>
                                    ))}
                                </div>
                            ) : (
                                <p style={{ color: '#666' }}>
                                    Sin desglose disponible.
                                </p>
                            )}
                            <Grid
                                container
                                style={{
                                    padding: '10px 0',
                                    fontWeight: 'bold',
                                    fontSize: '1.1em',
                                }}
                            >
                                <Grid item xs={8}>
                                    Total del servicio
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    style={{ textAlign: 'right' }}
                                >
                                    {object['total'] != null
                                        ? (+object['total']).toFixed(2)
                                        : '0.00'}{' '}
                                    €
                                </Grid>
                            </Grid>
                            <Grid container style={{ padding: '4px 0' }}>
                                <Grid item xs={8}>
                                    Cobrado
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    style={{ textAlign: 'right' }}
                                >
                                    {object['totalPay'] != null
                                        ? (+object['totalPay']).toFixed(2)
                                        : '0.00'}{' '}
                                    €
                                </Grid>
                            </Grid>
                            {object['paymentState'] == 'PARCIAL' && (
                                <p style={{ color: 'orange' }}>
                                    Pago parcial: queda saldo pendiente de
                                    cobro.
                                </p>
                            )}
                            {object['paymentState'] == 'ERROR' && (
                                <p style={{ color: 'red' }}>
                                    Error en el cobro de la liquidación.
                                </p>
                            )}
                            {object['motiveFiance'] &&
                                object['motiveFiance'] != '' && (
                                    <p>
                                        <b>Motivo: </b>
                                        {object['motiveFiance']}
                                    </p>
                                )}
                            {object['idBill'] && (
                                <div
                                    style={{
                                        textAlign: 'right',
                                        marginTop: '1em',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        style={{
                                            backgroundColor: '#83c63b',
                                            color: 'white',
                                        }}
                                        onClick={downloadInvoice}
                                    >
                                        Descargar factura
                                    </Button>
                                </div>
                            )}
                        </PanelForm>
                    </Grid>
                )}

                {/* F4 - Acciones de recepción durante el alquiler */}
                {isStart && (
                    <Grid
                        xs={12}
                        style={{ marginTop: '1em', textAlign: 'right' }}
                    >
                        <Button
                            variant="outlined"
                            color="warning"
                            style={{ marginLeft: '20px' }}
                            onClick={() => {
                                openCar(object['id'])
                            }}
                        >
                            Abrir puertas
                        </Button>
                        <Button
                            variant="outlined"
                            color="warning"
                            style={{ marginLeft: '20px' }}
                            onClick={() => {
                                closeCar(object['id'])
                            }}
                        >
                            Cerrar puertas
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginLeft: '20px' }}
                            onClick={() => {
                                setState((s) => ({
                                    ...s,
                                    openCommentStart: true,
                                    comment: '',
                                }))
                            }}
                        >
                            Comentario de inicio
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginLeft: '20px' }}
                            onClick={() => {
                                setState((s) => ({
                                    ...s,
                                    openCommentEnd: true,
                                    comment: '',
                                }))
                            }}
                        >
                            Comentario de fin
                        </Button>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: '20px' }}
                            onClick={() => {
                                endPay()
                            }}
                        >
                            Finalizar y liquidar
                        </Button>
                        <Button
                            variant="outlined"
                            color="warning"
                            style={{ marginLeft: '20px' }}
                            onClick={() => {
                                end()
                            }}
                        >
                            Finalizar sin cargos
                        </Button>
                    </Grid>
                )}
                {isCancellable && (
                    <Grid
                        xs={12}
                        style={{ marginTop: '1em', textAlign: 'right' }}
                    >
                        <Button
                            variant="outlined"
                            color="warning"
                            style={{ marginLeft: '20px' }}
                            onClick={() => {
                                cancel()
                            }}
                        >
                            Cancelar alquiler
                        </Button>
                    </Grid>
                )}
            </Grid>
            {error != '' && (
                <ModalBack>
                    <div>
                        <p>{error}</p>
                        <Button
                            onClick={closeModal}
                            variant="contained"
                            color="secondary"
                            style={{
                                margin: '10px 0 30px',
                            }}
                        >
                            OK
                        </Button>
                    </div>
                </ModalBack>
            )}
            {/* MOBD-66: aviso de bloqueo de usuario (contrato del backend). */}
            <BlockModal
                block={errorBlock}
                onClose={() => setState((s) => ({ ...s, errorBlock: null }))}
            />
            <ToastContainer />

            {/* Confirmar finalización sin cargos */}
            <Modal
                open={openModalConfirmFree}
                onClose={closeModalConfirmFree}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Box sx={style}>
                    <div style={{ marginBottom: '30px' }}>
                        ¿Finalizar el alquiler sin cargos? No se liquidará
                        ningún importe y se liberará la preautorización
                        completa.
                    </div>
                    <div>
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '30px' }}
                            onClick={closeModalConfirmFree}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                sendFreeFiance()
                            }}
                        >
                            Finalizar sin cargos
                        </Button>
                    </div>
                </Box>
            </Modal>

            {/* Confirmar finalización con liquidación automática */}
            <Modal
                open={openModalConfirmPay}
                onClose={closeModalConfirmPay}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Box sx={style}>
                    <div style={{ marginBottom: '30px' }}>
                        El backend calcula la liquidación automáticamente
                        (combustible, retraso, km y standby según la
                        modalidad) y la cobra de la preautorización. Indica el
                        motivo de la liquidación.
                    </div>
                    <div style={{ marginBottom: '30px' }}>
                        <TextField
                            variant="standard"
                            sx={{ width: '100%' }}
                            id={'motive'}
                            name={'motive'}
                            label={'Motivo'}
                            value={motive}
                            onChange={(evt) => {
                                setState((currentState) => ({
                                    ...currentState,
                                    ['motive']: evt.target.value,
                                }))
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            autoComplete="off"
                        />
                    </div>
                    <div>
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '30px' }}
                            onClick={closeModalConfirmPay}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={sendPayFiance}
                        >
                            Finalizar y liquidar
                        </Button>
                    </div>
                </Box>
            </Modal>

            {/* F4 - Comentario de inicio */}
            <Modal
                open={openCommentStart}
                onClose={closeCommentStart}
            >
                <Box sx={style}>
                    <div style={{ marginBottom: '20px' }}>
                        Comentario de recepción al iniciar el alquiler
                        (estado del vehículo, observaciones).
                    </div>
                    <div style={{ marginBottom: '30px' }}>
                        <TextField
                            variant="standard"
                            sx={{ width: '100%' }}
                            label={'Comentario'}
                            value={comment}
                            multiline
                            onChange={(evt) => {
                                setState((currentState) => ({
                                    ...currentState,
                                    ['comment']: evt.target.value,
                                }))
                            }}
                            InputLabelProps={{ shrink: true }}
                            autoComplete="off"
                        />
                    </div>
                    <div>
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '30px' }}
                            onClick={closeCommentStart}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={sendCommentStart}
                        >
                            Guardar comentario
                        </Button>
                    </div>
                </Box>
            </Modal>

            {/* F4 - Comentario de fin */}
            <Modal
                open={openCommentEnd}
                onClose={closeCommentEnd}
            >
                <Box sx={style}>
                    <div style={{ marginBottom: '20px' }}>
                        Comentario de recepción al finalizar el alquiler
                        (estado del vehículo, observaciones).
                    </div>
                    <div style={{ marginBottom: '30px' }}>
                        <TextField
                            variant="standard"
                            sx={{ width: '100%' }}
                            label={'Comentario'}
                            value={comment}
                            multiline
                            onChange={(evt) => {
                                setState((currentState) => ({
                                    ...currentState,
                                    ['comment']: evt.target.value,
                                }))
                            }}
                            InputLabelProps={{ shrink: true }}
                            autoComplete="off"
                        />
                    </div>
                    <div>
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '30px' }}
                            onClick={closeCommentEnd}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={sendCommentEnd}
                        >
                            Guardar comentario
                        </Button>
                    </div>
                </Box>
            </Modal>
        </CrudEmpty>
    )
}

const ModalBack = styled.div`
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    z-index: 2000;
    align-items: center;
    justify-content: center;

    & div {
        background: white;
        border-radius: 6px;
        padding: 1em;
        text-align: center;
        width: 600px;
        max-width: 80%;
    }
`

const PanelForm = styled.div`
    background: white;
    border-radius: 6px;
    padding: 15px;
`

const PanelAviso = styled.div`
    color: white;
    border-radius: 6px;
    padding: 14px 18px;
    margin-bottom: 1em;
    font-weight: bold;
    width: 100%;
`
